"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.reflect.construct.js");

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.match.js");

require("core-js/modules/es6.object.set-prototype-of.js");

require("core-js/modules/es6.object.get-prototype-of.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactS3Uploader = _interopRequireDefault(require("react-s3-uploader"));

var _utils = require("../../../../lib/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

require('../../../../sass/components/shared/elements/imageUpload/ImageUploader.css');

var ImageUploader = /*#__PURE__*/function (_React$Component) {
  _inherits(ImageUploader, _React$Component);

  var _super = _createSuper(ImageUploader);

  function ImageUploader(props) {
    var _this;

    _classCallCheck(this, ImageUploader);

    _this = _super.call(this, props);
    _this.state = {
      error: {},
      progress: null
    };
    _this.clickFileInput = _this.clickFileInput.bind(_assertThisInitialized(_this));
    _this.clearFileInput = _this.clearFileInput.bind(_assertThisInitialized(_this));
    _this.onUploadProgress = _this.onUploadProgress.bind(_assertThisInitialized(_this));
    _this.onUploadFinish = _this.onUploadFinish.bind(_assertThisInitialized(_this));
    _this.onUploadError = _this.onUploadError.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ImageUploader, [{
    key: "clickFileInput",
    value: function clickFileInput() {
      _reactDom.default.findDOMNode(this.s3Uploader).click();
    }
  }, {
    key: "clearFileInput",
    value: function clearFileInput() {
      _reactDom.default.findDOMNode(this.s3Uploader).value = '';
    }
  }, {
    key: "onUploadProgress",
    value: function onUploadProgress(progress) {
      this.props.handleProgress(progress);
    }
  }, {
    key: "onUploadFinish",
    value: function onUploadFinish(res) {
      var _this2 = this;

      var handleUpload = this.props.handleUpload;
      var match = res.signedUrl.match(/(.*)\?/);
      var url = match && match[1];

      if (!url) {
        return console.error('Something has happened in onUploadFinish that should not have.');
      }

      (0, _utils.postToImgCompressLambda)(url).then(function (result) {
        if (result.data.res === 'Success') {
          _this2.setState({
            img: result.data.path
          });

          handleUpload(result.data.path);
        } else {
          _this2.setState({
            img: url
          });

          handleUpload(url);
        }
      }).catch(function (err) {
        console.error('Something has happened in onUploadFinish that should not have: ', err);

        _this2.setState({
          img: url
        });

        handleUpload(url);
      });
    }
  }, {
    key: "onUploadError",
    value: function onUploadError(error) {
      console.error(error);
      this.setState({
        error: error
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          acceptedTypes = _this$props.acceptedTypes,
          label = _this$props.label,
          multiple = _this$props.multiple,
          render = _this$props.render,
          show = _this$props.show;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "image-uploader"
      }, render ? render() : /*#__PURE__*/_react.default.createElement("button", {
        className: "upload-button",
        onClick: function onClick() {
          _this3.clickFileInput();

          (0, _utils.googleAnalytics)('image_upload')();
        }
      }, label), /*#__PURE__*/_react.default.createElement(_reactS3Uploader.default, {
        multiple: multiple,
        accept: acceptedTypes,
        onSignedUrl: this.props.handleSignedUrl,
        onError: this.onUploadError,
        onFinish: this.onUploadFinish,
        onProgress: this.onUploadProgress,
        signingUrl: "/s3/dash/media/sign",
        ref: function ref(input) {
          return _this3.s3Uploader = input;
        },
        style: {
          display: show ? 'block' : 'none'
        }
      }));
    }
  }]);

  return ImageUploader;
}(_react.default.Component);

exports.default = ImageUploader;
ImageUploader.propTypes = {
  label: _propTypes.default.string,
  handleUpload: _propTypes.default.func,
  handleProgress: _propTypes.default.func,
  acceptedTypes: _propTypes.default.string,
  multiple: _propTypes.default.bool
};
ImageUploader.defaultProps = {
  label: 'Upload Image',
  handleUpload: function handleUpload() {},
  handleProgress: function handleProgress() {},
  acceptedTypes: 'image/*',
  multiple: false
};